(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanySubscriptionStatus', CompanySubscriptionStatus);

    CompanySubscriptionStatus.$inject = ['$resource', 'DateUtils'];

    function CompanySubscriptionStatus($resource, DateUtils) {
        var resourceUrl = 'api/company-subscription-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.expireDate = DateUtils.convertDateTimeFromServer(data.expireDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
